var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgImprove = function SvgImprove(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.918 5.417a.65.65 0 0 0 0-.175.533.533 0 0 0-.042-.142.917.917 0 0 0-.075-.117.625.625 0 0 0-.116-.141l-.1-.059a.575.575 0 0 0-.159-.083h-.166a.583.583 0 0 0-.175-.117h-4.167a.833.833 0 1 0 0 1.667h2.358l-3.333 3.925-3.6-2.142a.833.833 0 0 0-1.067.184l-4.166 5a.833.833 0 1 0 1.283 1.066l3.708-4.45 3.559 2.134a.833.833 0 0 0 1.058-.175l3.533-4.125v1.916a.833.833 0 0 0 1.667 0V5.417Z",
    fill: "#55A255",
    fillRule: "nonzero"
  })));
};
export default SvgImprove;